export const POSITIVE_FEEDBACK_OPTIONS = [{
  key: 'RELEVANT',
  I18LabelKey: `summary.description.feedback.form.RELEVANT`
}, {
  key: 'DETAILED',
  I18LabelKey: `summary.description.feedback.form.DETAILED`
}, {
  key: 'FACTUALLY_CORRECT',
  I18LabelKey: `summary.description.feedback.form.FACTUALLY_CORRECT`
}, {
  key: 'OTHER',
  I18LabelKey: `summary.description.feedback.form.OTHER`
}];
export const NEGATIVE_FEEDBACK_OPTIONS = [{
  key: 'NOT_RELEVANT',
  I18LabelKey: `summary.description.feedback.form.NOT_RELEVANT`
}, {
  key: 'NOT_DETAILED_ENOUGH',
  I18LabelKey: `summary.description.feedback.form.NOT_DETAILED_ENOUGH`
}, {
  key: 'NOT_FACTUALLY_CORRECT',
  I18LabelKey: `summary.description.feedback.form.NOT_FACTUALLY_CORRECT`
}, {
  key: 'OTHER',
  I18LabelKey: `summary.description.feedback.form.OTHER`
}];